module.exports = __webpack_public_path__ + "static/media/AUFS_Logo_EN.f9eaedc7.png";